<div class="custom-table mb-3">
	<div class="row custom-table-header">
		<div class="col align-self-center pl-3">
			<span class="title">
				{{ headerTitle() }}
				<mat-icon
					class="info-icon"
					aria-hidden="false"
					aria-label="icon displays a tooltip when focused or hovered over"
					matTooltip="{{titleTooltip}}"
					*ngIf="titleTooltip"
				>info</mat-icon>
			</span>
		</div>
		<!-- MENU -->
		<div class="col-auto mr-1 small-btn" *ngIf="editable">
			<button mat-icon-button type="button" (click)="addItem()">
				<span class="material-icons">add_circle_outline</span>
			</button>
		</div>
	</div>

	<form [formGroup]="formInputs">
		<app-loader-wrapper [loading]="!formData && !formData.items" size="sm" [ngClass]="{'custom-table-body': formData?.items?.length}">
			<div
				class="row align-items-center mx-0 p-1 custom-table-item bordered-top"
				*ngFor="let item of formData.items; let i = index"
			>
				<mat-form-field appearance="standard" class="col mx-auto form-field">
					<input
						matInput
						type="{{ formData.type }}"
						[placeholder]="formData.placeholder"
						[formControl]="formInputs.controls['item' + (i + 1)]"
					/>
					<mat-error
						appFormErrorMessage
						[errorFormControl]="formInputs.get('item' + (i + 1))"
						[type]="formData.type"
					></mat-error>
				</mat-form-field>
				<!-- MENU -->
				<div class="col-auto small-btn" *ngIf="editable && showDelete()">
					<button
						mat-icon-button
						type="button"
						(click)="deleteItem(i, item)"
						color="warn"
					>
						<span class="material-icons">delete_outline</span>
					</button>
				</div>
			</div>
		</app-loader-wrapper>
	</form>
</div>
